import React from 'react';
import { Content } from './Content';

export function Listing(): JSX.Element {
  return <Content />;
}
